import { 
    toDDMonFormatAEST,
    toDDMonYearFormatAEST 
} from "./header-format-date";

/**
 * Creates all the button tabs above the top of the table
 * @param {*} tableData The result object from the `districtFetchTableData`
 * @param {*} options The days to render
 * @param {*} selectedDay The day (option) that's currently been selected
 * @param {*} daysMap The reverseDayMap 
 * @param {*} btnClickCallback A handle to the function that handles the button click
 * @param {*} printBtnCallback A handle to the function that handles printing the page
 */
export function createButtonTabs(tableData, options, selectedDay, daysMap, btnClickCallback, printBtnCallback) {
    const headerContainer = $('#btn-header-container-id');

    const buttonTabsContainer = $('<div></div>');
    buttonTabsContainer.css({
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center'
    })
    const updateTimeContainer = $('<div></div');

    const earliestIssueTime = tableData.summary[selectedDay].data.find(
            e => e.issue_time != null);

    updateTimeContainer.text(`Updated at : ${toDDMonYearFormatAEST(earliestIssueTime.issue_time)}`);

    // Generate each of the buttons
    for(let idx = 0; idx < options.length; idx++) {
        const option = options[idx];
        if(option) {
                let headerBtnStyle = 'header-btn-style';
                if(idx === 0) {
                    headerBtnStyle = 'header-btn-style-on';
                }

            const btn = $(`<button id="${idx}-header-btn-id" ` + 
                    `type="button" ` + 
                    `class="${headerBtnStyle}" >` + 
                    `${option}` + 
                `</button>`);

            btn.on("click", function() {
                btnClickCallback(
                    tableData,
                    option,
                    daysMap);
            });

            // Check if this button is the selected day
            if(option === selectedDay) {
                btnClickCallback(
                    tableData,
                    option,
                    daysMap);
            }

            buttonTabsContainer.append(btn);

            const spacerDiv = $(`<div></div>`);
            spacerDiv.css({
                'padding': '0px 8px 0px 8px'
            });
            buttonTabsContainer.append(spacerDiv);
            
        }
    }

    const printBtn = $(`<button class="header-btn-style">Print page</button>`);
    printBtn.on('click', printBtnCallback);

    // Add the print button tab
    buttonTabsContainer.append(printBtn);

    // Add the button tabs container to the table container

    headerContainer.append(buttonTabsContainer);
    headerContainer.append(updateTimeContainer);
}